import { gql, useQuery } from "@apollo/client";
import AverageImage from "./assets/percent.svg";
import FastImage from "./assets/fast-forward.svg";
import TrendingUpImage from "./assets/trending-up.svg";
import TrendingDownImage from "./assets/trending-down.svg";
import {Loader} from '../utils/Loading'
import {ErrorHandler} from '../utils/Error'
import {DataBlock} from './DataBlock'

const GET_FEE = gql`
query GetFees {
  estimatedFee {
    txFees {
      average
      fast
    }
    snarkFees {
      maxFee
      minFee
      average
    }
  }
}
`

export const DataVisual = () => {

  const { loading, data, error } = useQuery(GET_FEE);

  if(loading) {
    return Loader
  }
  if(error) {
    return ErrorHandler
  }

  const averageFee =
    +data?.estimatedFee?.txFees?.average > 0.00000001
      ? data.estimatedFee.txFees.average
      : "0.000";
  const fastFee =
    +data?.estimatedFee?.txFees?.fast > 0.00000001
      ? data.estimatedFee.txFees.fast
      : "0.000";
  const maxSnark =
      +data?.estimatedFee?.snarkFees?.maxFee > 0.00000001
        ? data.estimatedFee.snarkFees.maxFee
        : "0.000";
  const minSnark =
      +data?.estimatedFee?.snarkFees?.minFee > 0.00000001
        ? data.estimatedFee.snarkFees.minFee
        : "0.000";
  const averageSnark =
      +data?.estimatedFee?.snarkFees?.average > 0.00000001
        ? data.estimatedFee.snarkFees.average
        : "0.000";

  return (<>
    <div className="full-width">
    <h2>Suggested Gas prices in Mina (Mainnet)</h2>
    <div className="row full-width">
      <div className="col-xl-4 col-md-6 col-sm-12">
        {DataBlock(AverageImage, 'Average', averageFee)}
      </div>
      <div className="col-xl-4 col-md-6 col-sm-12">
        {DataBlock(FastImage, 'Fast', fastFee, true)}
      </div>
    </div>
  </div>
  <h2>Snark prices in Mina (Mainnet)</h2>
  <div className="row full-width">
    <div className="col-md-4 col-sm-12">
      {DataBlock(TrendingUpImage, 'Highest price', maxSnark)}
    </div>
    <div className="col-md-4 col-sm-12">
    {DataBlock(AverageImage, 'Avg price', averageSnark, true)}
    </div>
    <div className="col-md-4 col-sm-12">
      {DataBlock(TrendingDownImage, 'Lowest Price', minSnark)}
    </div>
  </div>
  </>)
}
